import * as React from 'react';
import Base, { Props as BaseProps } from '../Base/Base';
import { IconMap, TypeIconName } from './tsx';
import './Icon.css';

export { TypeIconName };

export interface Props extends BaseProps {
  /** Name of the Icon to display */
  name: TypeIconName;
  /** Any CSS unit sizing for the Icon */
  size?: string;
}

/** Iconography component that output as crisp SVG icon. */
const Icon: React.FunctionComponent<Props> = (props: Props) => {
  const { name, size, ...rest } = props;
  const IconSVG = IconMap[name];

  return (
    <Base { ...rest }
        Component="svg"
        className="Icon"
        height={ size }
        viewBox="0 0 24 24"
        width={ size }>
      <IconSVG height="100%" width="100%" />
    </Base>
  );
};

Icon.defaultProps = {
  size: '1.5rem',
};

export default Icon;
